export enum VAT_SCREEN_LIST {

}

export enum VAT_REQUEST_ID_LIST {
  GET_VAT = 'GET_VAT',
  POST_VAT = 'POST_VAT',
  PATCH_VAT = 'PATCH_VAT',
  DELETE_VAT = 'DELETE_VAT',
  CALL_VATADD = 'CALL_VATADD',
  PATCH_VAT_DEFAULT = 'PATCH_VAT_DEFAULT',
  PATCH_VAT_TAXES = 'PATCH_VAT_TAXES'
}
